import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { DocumentLink } from '@/openapi';
import { DocumentsService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useUpdateDocumentLinkMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (documentLink: DocumentLink) => {
      return DocumentsService.documentsServiceUpdateDocumentLink({
        path: { id: documentLink.id },
        body: documentLink,
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.links(),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.metadata(),
        }),
      ]);
    },
  });
};
